(function () {
  'use strict';

  function updateNavState(root) {
    var scroller = root.querySelector('[data-bb-product-row-track]');
    var prevBtn = root.querySelector('[data-bb-product-row-prev]');
    var nextBtn = root.querySelector('[data-bb-product-row-next]');
    if (!scroller || !prevBtn || !nextBtn) return;

    var maxScroll = scroller.scrollWidth - scroller.clientWidth;
    var atStart = scroller.scrollLeft <= 1;
    var atEnd = scroller.scrollLeft >= maxScroll - 1;

    prevBtn.disabled = atStart;
    nextBtn.disabled = atEnd;
    root.classList.toggle('is-at-start', atStart);
    root.classList.toggle('is-at-end', atEnd);
  }

  function scrollByPage(root, direction) {
    var scroller = root.querySelector('[data-bb-product-row-track]');
    if (!scroller) return;

    var card = scroller.querySelector('.product-card');
    var gap = parseFloat(getComputedStyle(scroller).gap) || 16;
    var cardWidth = card ? card.offsetWidth + gap : scroller.clientWidth * 0.8;

    scroller.scrollBy({
      left: direction * cardWidth * 2,
      behavior: 'smooth',
    });
  }

  function initRow(root) {
    if (root.dataset.bbProductRowReady === 'true') return;
    root.dataset.bbProductRowReady = 'true';

    var scroller = root.querySelector('[data-bb-product-row-track]');
    var prevBtn = root.querySelector('[data-bb-product-row-prev]');
    var nextBtn = root.querySelector('[data-bb-product-row-next]');
    if (!scroller || !prevBtn || !nextBtn) return;

    prevBtn.addEventListener('click', function () {
      scrollByPage(root, -1);
    });

    nextBtn.addEventListener('click', function () {
      scrollByPage(root, 1);
    });

    scroller.addEventListener('scroll', function () {
      updateNavState(root);
    }, { passive: true });

    window.addEventListener('resize', function () {
      updateNavState(root);
    });

    updateNavState(root);
  }

  function initAll() {
    document.querySelectorAll('[data-bb-product-row]').forEach(initRow);
  }

  window.bbInitProductRow = initRow;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
